<template>
    <!-- 预览图像 -->
    <div v-if="visible">
        <div v-if="type == 'image'">
            <el-image-viewer
                v-show="previewLists.length"
                :url-list="previewLists"
                :on-close="handleClose"
            />
        </div>

        

        <div v-if="type == 'video'">
            <el-dialog v-model="visible" width="740px" title="视频预览" :before-close="handleClose">
                <video-player ref="playerRef" :src="url" width="100%" height="450px" />
            </el-dialog>
        </div>
    </div>
</template>
<script>
export default {
    /**
     * v-model 的value 和事件
     * v-model 是双向绑定
     */
     // ,
    model: {
        prop: 'value',
        event: 'change'// 需要emit(change)
    },
    props:{
        value: { //属性是否可见
            type: Boolean,
            default: false
        },
        // 图片或者视频的地址
        url: {
            type: [String,Array],
            default: [],
        },
        // 图片或者视频
        type: {
            type: String,
            default: 'image'
        }
    },

    components:{ 
        'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
    },

    data(){
        return{
            previewLists:[]
        }
    },

    methods:{
        handleClose(){
            //v-Model 语法糖 
            this.$emit("change",false);
            /**
             * 自定义事件 必须用.sync修饰符；子组件触发改变子组件
             */
            this.$emit("update:value", false);
        }
    },

    computed: {
        // 计算属性，根据prop 的变化而计算
        visible: function () {
            return this.value
        }
    },
    watch:{
        //观察 visible
        visible:function(newVal,oldVal){
            if(newVal){
                this.$nextTick(()=>{
                    //如果是字符串，则变成数组
                    if (typeof this.url === "string"){
                        var arrayUrl=[];
                        arrayUrl.push(this.url);
                        this.previewLists=arrayUrl;
                        // this.previewLists=[arrayUrl];
                        
                    }else{
                        
                        this.previewLists=this.url;
                    }
                  
                });
            }else{
                this.$nextTick(()=>{
                    this.previewLists=[];
                });
            }
        }
    },

}
</script>

<style lang="scss" scoped>

</style>